/* eslint-disable react/jsx-max-depth */
'use client';

import {
	Card,
	CloseButton,
	Dialog,
	Flex,
	For,
	HStack,
	Portal,
	Stack,
	Text,
	useDisclosure,
} from '@chakra-ui/react';
import { NextImageWithSkeleton, Rating } from '@packages/chakra-v3';
import React from 'react';
import { useState } from 'react';

type ProductReviewCardProps = {
	name:       string;
	rating:     number;
	reviewDate: string;
	content:    string;
	images:     string[];
};

const ProductReviewCard = ({
	name,
	rating,
	reviewDate,
	content,
	images,
}: ProductReviewCardProps) => {
	const { open, onOpen, onClose } = useDisclosure();
	const [ selectedImage, setSelectedImage ] = useState<string | null>(null);

	const handleImageClick = (image: string) => {
		setSelectedImage(image);
		onOpen();
	};

	return (
		<React.Fragment>
			<Card.Root>
				<Card.Body display={'flex'} flexDir={'column'} gap={4}>
					<Stack gap={2}>
						<Text
							fontWeight={800}
							textStyle={'16px'}
							textTransform={'uppercase'}
						>
							{name}
						</Text>
						<HStack alignItems={'center'} gap={4}>
							<Rating
								allowHalf
								readOnly
								defaultValue={rating}
								height={'14px'}
								size={'lg'}
							/>
							<Text lineHeight={1} textStyle={'14px'}>{reviewDate}</Text>
						</HStack>
					</Stack>
					<Text textStyle={'p3'}>
						{content}
					</Text>
				</Card.Body>
				<Card.Footer>
					<Flex gap={4}>
						<For each={images}>
							{image => (
								<NextImageWithSkeleton
									key={image}
									alt={'user-review-image'}
									aspectRatio={'square'}
									height={'100px'}
									src={image}
									onClick={() => handleImageClick(image)}
								/>
							)}
						</For>
					</Flex>
				</Card.Footer>
			</Card.Root>
			<Dialog.Root
				open={open}
				size={'xl'}
				onOpenChange={onClose}
			>
				<Portal>
					<Dialog.Backdrop />
					<Dialog.Positioner>
						<Dialog.Content>
							<Dialog.Header p={0} position={'relative'}>
								{selectedImage && (
									<NextImageWithSkeleton
										key={selectedImage}
										alt={'user-review-image'}
										aspectRatio={'square'}
										src={selectedImage}
										width={'100%'}
									/>
								)}
								<Dialog.CloseTrigger asChild>
									<CloseButton
										bg={'gray.900'}
										color={'white'}
										m={0}
										position={'absolute'}
										right={0}
										size={'lg'}
										top={0}
										w={'fit-content'}
									/>
								</Dialog.CloseTrigger>
							</Dialog.Header>
						</Dialog.Content>
					</Dialog.Positioner>
				</Portal>
			</Dialog.Root>
		</React.Fragment>
	);
};

export default ProductReviewCard;